import { LocationForm } from "../LocationForm";

export interface AddLocationProps {}

export const AddLocation = () => {
  return <LocationForm />;
};
